import { httpApi } from '@api/http.api.ts';
import type { ClientInfo } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___pages___/client-info/api/clientInfo.api.ts';
import type {
    DefaultUserPreferences,
    TenantType,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___pages___/tenant-info/api/tenantInfo.api.ts';

export interface ClientTenantFullDetails {
    client: ClientInfo;
    tenant: {
        id: number;
        name: string;
        alias: string;
        logoUrl: string;
        tenantUrl: string;
        displayName: string;
        isActive: boolean;
        canBeActivated: boolean;
        defaultUserPreferences: DefaultUserPreferences;
        tenantType: TenantType;
    };
}

const getTenantBaseUrl = (clientId: number) => `admin-center/clients/${clientId}/tenants`;

export const getApiClientTenantByAliasFullDetails = (
    clientId: number,
    alias: string,
): Promise<ClientTenantFullDetails> =>
    httpApi
        .get<ClientTenantFullDetails>(`${getTenantBaseUrl(clientId)}/${alias}/full-details`)
        .then(({ data }) => data);
